// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3-3bU","label":"Completed_label__3Yx5P"};